import { css } from '@spectrum-web-components/base';
const styles = css`
    slot[name=longpress-describedby-descriptor]{display:none}
`;
export default styles;